
import React from 'react';

const scrollOnClose = (setShouldScroll: React.Dispatch<React.SetStateAction<boolean>>) => {
  const topRailFilterButton = document.querySelector(
    '.top-rail__filter-button',
  ) as HTMLElement;
  const brandBarHeader = document.querySelector('.brand-bar__header') as HTMLElement;
  
  const topRailFilterButtonTop = topRailFilterButton?.offsetTop || 0;
  const navigationHeight = brandBarHeader?.offsetHeight || 0;
  const top = topRailFilterButtonTop - navigationHeight;
  
  window.scrollTo?.({ top, behavior:'smooth' });
  
  setShouldScroll(false);
};
  
export default scrollOnClose;
  